/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplementalServiceVersion
 */
export interface SupplementalServiceVersion {
    /**
     * GIT Commit version of Service
     * @type {string}
     * @memberof SupplementalServiceVersion
     */
    version?: string;
}

/**
 * Check if a given object implements the SupplementalServiceVersion interface.
 */
export function instanceOfSupplementalServiceVersion(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SupplementalServiceVersionFromJSON(json: any): SupplementalServiceVersion {
    return SupplementalServiceVersionFromJSONTyped(json, false);
}

export function SupplementalServiceVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalServiceVersion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function SupplementalServiceVersionToJSON(value?: SupplementalServiceVersion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': value.version,
    };
}

